// extracted by mini-css-extract-plugin
export default {"failScreenText":"TcsoInventoryResult_failScreenText__ofdkk","bodyTitleText":"TcsoInventoryResult_bodyTitleText__K0NQK","bodyText":"TcsoInventoryResult_bodyText__C6quI"};